import * as $ from "jquery";

export default class ProductModal {
	container: HTMLElement;
	contentWrapper: HTMLElement;
	content: HTMLElement;
	overlay: HTMLElement;
	closeButton: HTMLButtonElement;

	details: any;
	factsEl: HTMLElement;

	visible: boolean = false;

	video: HTMLVideoElement;

	strings: any = {};

	constructor(elementSelector:string) {
		this.container = <HTMLElement> document.querySelector('[data-modal="'+elementSelector+'"]');
		if (this.container) {
			this.contentWrapper = <HTMLElement> this.container.querySelector('.modal-content__wrapper');
			this.content = <HTMLElement> this.container.querySelector('.modal-content');
			this.overlay = <HTMLElement> this.container.querySelector('.overlay');
			this.closeButton = <HTMLButtonElement> this.container.querySelector('.close-modal');

			this.overlay.addEventListener("click", (e) => {
				this.hide();
			});

			if (this.closeButton) {
				this.closeButton.addEventListener("click", (e) => {
					e.preventDefault();
					this.hide();
				});
			}

			if(elementSelector === "watch-video") {
				this.video = <HTMLVideoElement> this.container.querySelector("video");

				this.video.addEventListener("click", (e) => {
					this.video.paused ? this.video.play() : this.video.pause();
				});
			}
			const hashLoad = this.container.getAttribute("data-hashload");

			if(window.location.hash && hashLoad != 'false') {
				if(window.location.hash.substring(1) === elementSelector) {
					this.show();
				}
			}

			if (document.getElementById("freal-product-archive-strings")) {
				this.strings = JSON.parse(document.getElementById("freal-product-archive-strings").innerHTML);
				console.log(this.strings);
			}
		} else {
			console.warn('Error creating modal: ' + elementSelector);
		}
	}

	updateContent(details: any, factsEl?: HTMLElement) {
		if (details) {
			this.details = details;
			this.factsEl = factsEl;

			let markup = `
			<div class="product-details-wrapper">
				<header style="background-color: ${details.highlight_color}">
					<div class="columns">
						<div class="featured-image">
							<img src="${details.featured_image}" />
						</div>
						<div class="title-image" style="background-image: url(${details.title_image})"></div>
					</div>
					<div class="description">${details.description}</div>
				</header>
				<div class="columns">
					<div class="nutrition-facts">
						<h2>${this.strings.nutrition_facts}</h2>
						${this.factsEl.outerHTML}
					</div>
					<div class="ingredients wysiwyg">
						<h2>${this.strings.ingredients}</h2>
						<p>${details.ingredients}</p>
					</div>
				</div>
			</div>
			`;

			if (!this.visible) {
				this.content.innerHTML = markup;
				this.content.removeAttribute("data-loading");
				this.contentWrapper.removeAttribute("data-loading");
			} else {
				this.content.setAttribute("data-loading", "true");
				this.contentWrapper.setAttribute("data-loading", "true");
				setTimeout(() => {
					this.content.innerHTML = markup;
				}, 200);
				setTimeout(() => {
					this.content.removeAttribute("data-loading");
					this.contentWrapper.removeAttribute("data-loading");
				}, 400);
			}

		} else {
			this.content.innerHTML = "";
		}
	}

	show() {
		this.visible = true;
		this.updateNavButtons();
		this.container.setAttribute("data-status", "active");
	}

	hide() {
		this.visible = false;
		this.updateNavButtons();
		this.container.removeAttribute("data-status");
	}

	updateNavButtons() {
		$('.pagination-button').each((i, el) => {
			if (this.visible) {
				$(el).addClass('modal-active');
			} else {
				$(el).removeClass('modal-active');
			}
		});
	}
}